import { Calendar, TrafficPeriod } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum TrafficPeriodSelectionActionTypes {
  FetchSelectableTrafficPeriods = '[CalendarEdit] Fetch Selectable Traffic Periods',
  FetchSelectableTrafficPeriodsSuccess = '[CalendarEdit] Fetch Selectable Traffic Periods Success',
  FetchSelectableTrafficPeriodsFail = '[CalendarEdit] Fetch Selectable Traffic Periods Fail',

  ApplyTrafficPeriod = '[CalendarEdit] Apply Traffic Period',
  ApplyTrafficPeriodSuccess = '[CalendarEdit] Apply Traffic Period Success',
  ApplyTrafficPeriodFail = '[CalendarEdit] Apply Traffic Period Fail',
}


export class FetchSelectableTrafficPeriods implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.FetchSelectableTrafficPeriods;
  constructor(public payload: number) {}
}

export class FetchSelectableTrafficPeriodsSuccess implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.FetchSelectableTrafficPeriodsSuccess;
  constructor(public payload: TrafficPeriod[]) {}
}

export class FetchSelectableTrafficPeriodsFail implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.FetchSelectableTrafficPeriodsFail;
  constructor(public payload: Error) {}
}

export class ApplyTrafficPeriod implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.ApplyTrafficPeriod;
  constructor(public payload: number) {}
}

export class ApplyTrafficPeriodSuccess implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.ApplyTrafficPeriodSuccess;
  constructor(public payload: Calendar) {}
}

export class ApplyTrafficPeriodFail implements Action {
  readonly type = TrafficPeriodSelectionActionTypes.ApplyTrafficPeriodFail;
  constructor(public payload: Error) {}
}

export type TrafficPeriodSelectionActions =
  | FetchSelectableTrafficPeriods
  | FetchSelectableTrafficPeriodsSuccess
  | FetchSelectableTrafficPeriodsFail
  | ApplyTrafficPeriod
  | ApplyTrafficPeriodSuccess
  | ApplyTrafficPeriodFail;
